import _ from 'lodash';
import moment from 'moment';
// ================================================================================================
export const enum eCustomDateRange {
    None = '',
    'Today' = 'Today',
    'Yesterday' = 'Yesterday',
    'Last 7 Days' = 'Last 7 Days',
    'Last 30 Days' = 'Last 30 Days',
    'This Month' = 'This Month',
    'Last Month' = 'Last Month',
    'Last Year' = 'Last Year'
}
// ------------------------------------------------------------------------------------------------
export function customRanges(key: string): [moment.Moment, moment.Moment] {
    let result: [moment.Moment, moment.Moment] = [moment(), moment()];
    switch (key) {
        case eCustomDateRange.Today: result = [moment(), moment()]; break;
        case eCustomDateRange.Yesterday: result = [moment().subtract(1, 'days'), moment().subtract(1, 'days')]; break;
        case eCustomDateRange["Last 7 Days"]: result = [moment().subtract(6, 'days'), moment()]; break;
        case eCustomDateRange["Last 30 Days"]: result = [moment().subtract(29, 'days'), moment()]; break;
        case eCustomDateRange["This Month"]: result = [moment().startOf('month'), moment().endOf('month')]; break;
        case eCustomDateRange["Last Month"]: result = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]; break;
        case eCustomDateRange["Last Year"]: result = [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]; break;
    }

    result[0].startOf("day");
    result[1].endOf("day");
    return result;
}
// ------------------------------------------------------------------------------------------------
export const eCustomDateRangeToButtonMessage: { [key: string]: string } = {
    [eCustomDateRange.Today]: "Day",
    [eCustomDateRange.Yesterday]: "Day",
    [eCustomDateRange["Last 7 Days"]]: "Week",
    [eCustomDateRange["Last 30 Days"]]: "30 Days",
    [eCustomDateRange["This Month"]]: "Month",
    [eCustomDateRange["Last Month"]]: "Month",
    [eCustomDateRange["Last Year"]]: "Year"
}
// ------------------------------------------------------------------------------------------------
export function customRangesDictionary(): { [key: string]: [moment.Moment, moment.Moment] } {
    let range: { [key: string]: [moment.Moment, moment.Moment] } = {
        [eCustomDateRange.Today]: [moment(), moment()],
        [eCustomDateRange.Yesterday]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        [eCustomDateRange["Last 7 Days"]]: [moment().subtract(6, 'days'), moment()],
        [eCustomDateRange["Last 30 Days"]]: [moment().subtract(29, 'days'), moment()],
        [eCustomDateRange["This Month"]]: [moment().startOf('month'), moment().endOf('month')],
        [eCustomDateRange["Last Month"]]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        [eCustomDateRange["Last Year"]]: [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]
    };

    _.forEach(range, r => {
        r[0].startOf("day");//.set({ "hour": 0, "minute": 0, "second": 0 });
        r[1].endOf("day");//.set({ "hour": 23, "minute": 59, "second": 59 });
    });

    return range;
}
// ------------------------------------------------------------------------------------------------
export function GetDateRangeToolItemLocalizationDictionary(): { [key: string]: string } {
    const res = {};

    // fill dictionary with custom ranges' keys
    _.forOwn(customRangesDictionary(), (value, key) => {
        // copy keys from `customRanges`
        res['customRange_' + key] = key;
        // copy values from `eCustomDateRangeToButtonMessage`
        res['customRangeToButtonMessage_' + key] = eCustomDateRangeToButtonMessage[key];
    });

    // next/previous button messages
    res['msg_next'] = 'Next';
    res['msg_previous'] = 'Previous';

    return res;
}